import React from "react";
import Modal from "react-modal";
import { Helmet } from "react-helmet";

Modal.setAppElement("#root");

export const Iclreact = (props) => {
  //  const [modalIsOpen,setModalIsOpen] = useState(false);
  // const [videoIsOpen,setVideoIsOpen] = useState(false);  
  // const [isLoading,setLoading] = useState(true);
  //  const videoId='https://iclvideos.s3.ap-south-1.amazonaws.com/chatbots/Support_ChatBot.mp4'; ///to be updated

  return (
    <div id="iclreact" className="text-center">
      {props.isStandalone && (
      <Helmet htmlAttributes={{ lang: "en" }}>
        <title>ICL React App - Training Videos & Client Support</title>

        <link rel="canonical" href="https://eximon.com/iclreact" />

        <meta charSet="utf-8" />
        <meta
          name="description"
          content="The ICL React Android app provides clients with training videos, AI chatbot support, and a ticketing system for ICL Software services—all in one convenient platform."
        />

        {/* Open Graph */}
        <meta property="og:title" content="ICL React App - Training Videos & Client Support" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://eximon.com/iclreact" />
        <meta
          property="og:description"
          content="Access training resources, raise support tickets, and use AI chatbot assistance through the ICL React Android app."
        />
        <meta property="og:image" content="https://eximon.com/img/apple-touch-icon.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ICL React App - Training Videos & Client Support" />
        <meta
          name="twitter:description"
          content="The ICL React Android app provides training videos, chatbot support, and ticketing for ICL Software clients."
        />
        <meta name="twitter:image" content="https://eximon.com/img/apple-touch-icon.png" />
      </Helmet>
)}
      <div className="container">
        <div className="section-title">
          <h1>ICL Reacts (Mobile App)</h1>
          <h2>Access all essential software training resources for the ICL Software in one convenient place.</h2>
          <div className="btn-group">
            <button onClick={() => window.open('https://tinyurl.com/eximon', '_blank')} type="button" className="btn btn-custom btn-lg" >
              Download
            </button>
            {/* <button onClick={()=>setVideoIsOpen(true)} type="button" className="btn btn-custom btn-lg" >
                  Demo
                </button>               
                <Modal 
        isOpen={videoIsOpen} 
        onRequestClose={() => setVideoIsOpen(false)}
        style={{
          content: {
            position: 'absolute',
            top: 'auto',
            left: '10px',
            right: 'auto',
            bottom: '20px',
            width: '70%',
            height: '60%'
          }
        }}
      >

        {isLoading && <div style={{fontWeight:"bold"}}>Please wait loading ...</div>}
        <iframe 
          title="ICL React Demo" 
          src={videoId}  
          allowFullScreen 
          style={{ width: '100%', height: '90%' }} onLoad={()=>setLoading(false)}
        />
        {!isLoading && 
                        <button onClick={()=>{setVideoIsOpen(false);setLoading(true);}} type="button" className="btn btn-custom btn-lg" >
                  Close
                </button> 
}               
        </Modal> */}
          </div>
        </div>
        <div className="row" style={{ marginTop: '10px' }}>
          {
            props.data
              ? props.data.map((d, i) => (
                <div key={`${d.Title}-${i}`} className="col-md-4">
                  <div className="caption">
                    {d.Title && <h2>{d.Title}</h2>}
                  </div>
                  <div>
                    {d.Subtitle && <h3>{d.Subtitle}</h3>}
                    {/* {d.Paragraph} */}
                    {d.Paragraph.map((item, j) => {
                      switch (item.type) {
                        case "text":
                          return <span key={j}>{item.content}</span>;
                        case "list":
                          return (
                            <ul key={j}>
                              {item.items.map((listItem, k) => (
                                <li key={k} style={{ textAlign: "left", marginBottom: "5px" }} dangerouslySetInnerHTML={{ __html: listItem }}></li>
                              ))}
                            </ul>
                          );
                        case "bold":
                          return <strong key={j}>{item.content}</strong>;
                        default:
                          return null;
                      }
                    })}
                  </div>
                </div>
              ))
              : "loading"}
        </div>
      </div>
    </div>

  );
};
